// extracted by mini-css-extract-plugin
module.exports = {"dialog":"bespoken_drawer__dialog--3DEnm","drawer":"bespoken_drawer__drawer--3d3mC"};